import intermind from '../../../index';
import { ListConfig, ListParams, ListResponse, Subscription } from '../../../types';

export class SubscriptionResource {
  async listConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>('/billing/subscriptions/list-config');
    return data;
  }

  async list(params: ListParams): Promise<ListResponse<Subscription>> {
    const { data } = await intermind.httpClient.get<ListResponse<Subscription>>('/billing/subscriptions', {
      params,
    });
    return data;
  }

  async cancel(): Promise<void> {
    await intermind.httpClient.post('/billing/subscriptions/cancel');
  }
}
